module.exports = __webpack_public_path__ + "OpenSans-LightItalic-e7cc7120e670a8073073dbc3e4ff0184.woff2";